// extracted by mini-css-extract-plugin
export default {"duplicate":"Duplicate_duplicate__uhw2v","is-disabled":"Duplicate_is-disabled__CxQXD","duplicate-modal":"Duplicate_duplicate-modal__KRTnu"};